import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AuthorityIndicator, } from './authority-indicator.js';
const PHASES = [
    {
        kind: 'provider-initiated',
        label: 'Provider initiated',
        description: 'Provider clinical workflow triggered the federated prior-auth request at their local EHR. Smart Widget invoked.',
    },
    {
        kind: 'authz-decision',
        label: 'Substrate authority routing',
        description: 'Smart Health Network routed the request via Smart ID v0.3 three-layer architecture. Authority frame evaluated.',
    },
    {
        kind: 'payer-adjudication',
        label: 'Payer adjudication',
        description: 'Payer received the federated query. Provider evidence packet evaluated against payer-published criteria in place.',
    },
    {
        kind: 'pa-tracker-update',
        label: 'Decision returned',
        description: 'Payer decision (approval or denial) + cited rationale routed back to provider AND patient simultaneously.',
    },
    {
        kind: 'audit-publication',
        label: 'Audit chain published',
        description: 'Multi-party-signed audit record emitted. SHN PBC + Smart Health Trust + Smart Health Council attest.',
    },
];
function decisionToIndicatorState(decision) {
    switch (decision) {
        case 'pending':
            return { state: 'inactive', label: 'Pending substrate routing' };
        case 'in-review':
            return { state: 'sandbox', label: 'In review' };
        case 'approved':
            return { state: 'active', label: 'Approved' };
        case 'denied':
            return { state: 'inactive', label: 'Denied' };
    }
}
export function PaTrackerView(props) {
    const { currentPhaseIndex, decisionState, testId } = props;
    const { state: indicatorState, label: indicatorLabel } = decisionToIndicatorState(decisionState);
    return (_jsxs("section", { className: "pa-tracker-view", "data-testid": testId ?? 'pa-tracker-view', "data-current-phase": currentPhaseIndex, "data-decision-state": decisionState, "aria-labelledby": "pa-tracker-view-heading", children: [_jsxs("header", { className: "pa-tracker-view__header", children: [_jsx("h3", { id: "pa-tracker-view-heading", children: "Prior authorization tracker" }), _jsx(AuthorityIndicator, { state: indicatorState, contextLabel: indicatorLabel })] }), _jsx("p", { className: "pa-tracker-view__synthetic-disclaimer", role: "note", children: "Synthetic patient \u00B7 Sandbox-tier demonstration. The clinical scenarios you see are synthetic. The substrate operates as architected; the data is not real." }), _jsx("ol", { className: "pa-tracker-view__timeline", "aria-label": "Prior authorization phase timeline", children: PHASES.map((phase, i) => {
                    const status = i < currentPhaseIndex
                        ? 'completed'
                        : i === currentPhaseIndex
                            ? 'current'
                            : 'upcoming';
                    return (_jsxs("li", { className: `pa-tracker-view__phase pa-tracker-view__phase--${status}`, "data-phase": phase.kind, "data-status": status, "aria-current": status === 'current' ? 'step' : undefined, children: [_jsx("span", { className: "pa-tracker-view__phase-indicator", "aria-hidden": "true", children: status === 'completed' ? '✓' : status === 'current' ? '●' : '○' }), _jsxs("div", { className: "pa-tracker-view__phase-content", children: [_jsx("h4", { className: "pa-tracker-view__phase-label", children: phase.label }), _jsx("p", { className: "pa-tracker-view__phase-description", children: phase.description })] })] }, phase.kind));
                }) })] }));
}
//# sourceMappingURL=pa-tracker-view.js.map